// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"456":"02e29ca8","660":"5b1c1c63"}[chunkId] + ".chunk.js";
};